module.exports = __webpack_public_path__ + "img/home-restaurant-03.b248f7ba.jpg";